import React from 'react'
import { DateTimePicker } from 'react-widgets'
import { isNumber, isString, isBoolean } from 'lodash'
import m from 'moment'
import {
  Row, Col, Modal, ButtonGroup,
  Form, FormGroup, FormControl, ControlLabel, Checkbox, Radio
} from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import MarkdownField from '../lib/MarkdownField'
import Button from '../components/Button'
import { getText } from '../lib/text.js'
import { round, printMoney, str2date, date2str } from '../../lib/Tools'
import { eur2yuan, yuan2eur } from '../lib/exchangeRateClient'
import config from '../../../config.app'

// @TODO many texts here are missing in text_data

/**
 *
 */

type ModalProps = {
  payment: Object,
  onChange: (Object => void),
  onCancel: () => void,
  isNewPayment: boolean
}

// const PaymentModal = ({ payment, onChange, onClose}: ModalProps) => (

class PaymentModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      isEurEdited : false,
      isYuanEdited : false,
      paymentMethod: "tripmaker"
    }
  }

  props : ModalProps

  render() {
    const { tripId, payment, onCancel } = this.props
    const link = config.tripmaker_payment_link(tripId, payment.key)
    console.log(this.props)
    return (
      <Modal show onHide={() => this.props.onCancel()}>
        <Modal.Header>
          <Modal.Title>
            {getText("Enlace de pago")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Link: {link}</div>
          <CopyToClipboard 
            text={link}
          >
            <Button 
              bsSize="xsmall" 
              bsStyle={this.state.copiedPayment == payment.key ? 'primary' : 'default'}
              style={{ marginLeft: 5 }}
            >
             Copiar
            </Button>
          </CopyToClipboard>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onCancel()}>
            {getText("Cerrar")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default PaymentModal
